<template>
  <div id="user-list">
    <solicitante-dialog-tabs
      :is-configurar-solicitante-dialog-open="isConfigurarSolicitanteDialogOpen"
      :solicitante-id="solicitanteId"
      :close-dialog="closeDialog"
      @refetch-data="getSolicitantes"
    />

    <v-card>
      <v-card-text class="d-flex align-center flex-wrap pb-0">
        <v-text-field
          v-model.trim="search"
          placeholder="Pesquisar"
          dense
          outlined
          hide-details
          class="user-search me-3"
          @keyup="getSolicitantes"
        />

        <v-spacer></v-spacer>

        <div class="d-flex align-center flex-wrap">
          <v-btn
            color="success"
            class="px-4"
            @click.stop="isConfigurarSolicitanteDialogOpen = !isConfigurarSolicitanteDialogOpen"
          >
            <v-icon
              left
              size="25"
              class="mr-1"
            >
              {{ icons.mdiAccountPlusOutline }}
            </v-icon>
            <span>Cadastrar</span>
          </v-btn>
        </div>
      </v-card-text>

      <v-col cols="12">
        <div style="min-height: 4px">
          <v-progress-linear
            v-if="loading"
            indeterminate
          />
        </div>

        <table-solicitantes
          :items="solicitatensDataLocale"
          :selecionar-solicitante="selecionarSolicitante"
        />
      </v-col>
    </v-card>
  </div>
</template>

<style lang="scss">
@import '@core/preset/preset/apps/user.scss';
</style>

<script>
import { ref, onMounted } from '@vue/composition-api'
import { mdiAccountPlusOutline } from '@mdi/js'
import TableSolicitantes from '@/components/tables/TableSolicitantes.vue'
import SolicitanteDialogTabs from '@/views/solicitante/SolicitanteDialogTabs.vue'
import ClienteService from '@/services/modules/ClienteService'

export default {
  components: {
    TableSolicitantes,
    SolicitanteDialogTabs,
  },

  setup() {
    const isConfigurarSolicitanteDialogOpen = ref(false)

    const respSolicitantes = ref([])
    const solicitatensDataLocale = ref([])
    const loading = ref(false)
    const search = ref('')

    async function tratarDadosSolicitantes(item) {
      const dadoTratado = item
      dadoTratado.forEach(element => {
        if (element.contatos.length > 0) {
          element.email = element.contatos[0].email
          element.celular = element.contatos[0].celular
        }
      })
      return dadoTratado
    }

    async function getSolicitantes() {
      try {
        loading.value = true
        respSolicitantes.value = await ClienteService.getSolicitantes()

        solicitatensDataLocale.value = await tratarDadosSolicitantes(respSolicitantes.value)

        if (search.value) {
          solicitatensDataLocale.value = solicitatensDataLocale.value.filter(it => it.nome && it.nome.toUpperCase().includes(search.value.toUpperCase()))
        }
        solicitatensDataLocale.value.sort((a, b) => new Date(b.dataCadastro) - new Date(a.dataCadastro))
      } finally {
        loading.value = false
      }
    }
    onMounted(async () => { await getSolicitantes() })

    const solicitanteId = ref(0)

    function selecionarSolicitante(solicitante) {
      solicitanteId.value = solicitante.id
      isConfigurarSolicitanteDialogOpen.value = true
    }

    function closeDialog() {
      isConfigurarSolicitanteDialogOpen.value = false
      solicitanteId.value = 0
    }

    return {
      isConfigurarSolicitanteDialogOpen,
      solicitatensDataLocale,
      loading,
      search,
      getSolicitantes,
      solicitanteId,
      selecionarSolicitante,
      closeDialog,
      icons: { mdiAccountPlusOutline },
    }
  },
}
</script>
